import { Upsell } from '@/interfaces/models/Upsell';
import ApiService from '@/api/http/ApiService';
import axios, { AxiosPromise } from 'axios';
import { UpsellType } from '@/enums/UpsellType';

export class UpsellApiService extends ApiService<Upsell> {
  constructor() {
    super('general/upsells');
  }

  public showByVenueAndType(venue: string, type: UpsellType): AxiosPromise<Upsell> {
    return axios.get(`${this.getBaseUrl()}/venue/${venue}/type/${type}`);
  }
}
